import { render, staticRenderFns } from "./ViewEditHistory.vue?vue&type=template&id=113499d5"
import script from "./view-edit-history.ts?vue&type=script&lang=ts&external"
export * from "./view-edit-history.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports